import { useAdvanceSearchContext } from "./AdvanceSearchContextTest";
import { useRef } from "react";
import "./AdvanceSearch.scss";
import Card from "react-bootstrap/Card";
import { Competences } from "./cards/competences";
import { Global } from "./cards/global";
import { Conditions } from "./cards/conditions";
import { PersonalInformation } from "./cards/personalInformation";
import { Work } from "./cards/work";
import { Education } from "./cards/education";
import { useState } from "react";
import { ValidateFields } from "./ValidateFields";
import { showError } from "../../../services/ModalService";
import { ApplicationDetails} from "./cards/applicationDetails";

import SaveSearch from "./SaveSearch";

export default function SearchTab() {
  let { searchObject } = useAdvanceSearchContext();
  const [showSaveSearch, setShowSaveSearch] = useState(false);

  let mobilityRef = useRef();
  const {
    executeSearch,
    saveSearch,
    t,
    clear,
    cardStatus,
    buttonStatus,
    changebuttonStatus,
    changeCardStatus,
    setButtonStatus,
    setActiveTab,
    storedSearch,
    setStoredSearch
  } = useAdvanceSearchContext();

  function ClearAll() {
    if (mobilityRef.current) {
      mobilityRef.current.reset();
    }
    setButtonStatus({
      competence: false,
      global: false,
      condition: false,
      personal: false,
      work: false,
      education: false,
      applicationDetails: false
    });

    clear();
  }

  function onCardButtonClick(buttonName) {
    if (ValidateFields[buttonName](searchObject) === "") {
      changebuttonStatus(buttonName);
      if (!buttonStatus[buttonName]) {
        changeCardStatus(buttonName);
      }
    } else {
      showError(t("please clear card inputs first"));
    }
  }
  function cancelEdit() {
    setStoredSearch(null);
    setActiveTab("mySearches");
  }

  return (
    <>
      <div>
        <div className="position-button-search">
          <button onClick={ClearAll} className="app-button btn-second btn-md">
            {t("Clear")}
          </button>
          <button
            onClick={executeSearch}
            className="app-button btn-prime btn-md"
          >
            {t("Search")}
          </button>
          {!storedSearch && (
            <button
              onClick={() => setShowSaveSearch(true)}
              className="app-button btn-prime btn-md"
            >
              {t("Save Search")}
            </button>
          )}
          {storedSearch && (
            <>
              <button
                onClick={() => cancelEdit()}
                className="app-button btn-second  btn-md"
              >
                {t("Cancel")}
              </button>
              <button
                onClick={() => saveSearch(storedSearch.name)}
                className="app-button btn-prime btn-md"
              >
                {t("Save")}
              </button>
            </>
          )}
        </div>
        <div className="row">
          <div className="col-1 align-bottom">
            <label className="form-label col-1">{t("Filters")}</label>
          </div>
        </div>
        <div
          className="container-fluid d-flex flex-wrap"
          style={{ marginLeft: "-30px" }}
        >
          <Card className="border-card">
            <button
              onClick={() => onCardButtonClick("competence")}
              id="card-button-competence"
              variant="primary"
              className={`app-button btn-second margim-buttons ${
                buttonStatus.competence ? "btn-active" : "btn-inactive"
              }`}
            >
              {t("Skills")}
            </button>
          </Card>
          <Card className="border-card">
            <button
              onClick={() => onCardButtonClick("global")}
              id="card-button-global"
              variant="primary"
              className={`app-button btn-second margim-buttons ${
                buttonStatus.global ? "btn-active" : "btn-inactive"
              }`}
            >
              {t("Global")}
            </button>
          </Card>
          <Card className="border-card">
            <button
              onClick={() => onCardButtonClick("condition")}
              id="card-button-condition"
              variant="primary"
              className={`app-button btn-second margim-buttons ${
                buttonStatus.condition ? "btn-active" : "btn-inactive"
              }`}
            >
              {t("Conditions")}
            </button>
          </Card>
          <Card className="border-card">
            <button
              onClick={() => onCardButtonClick("personal")}
              id="card-button-personal"
              variant="primary"
              className={`app-button btn-second margim-buttons ${
                buttonStatus.personal ? "btn-active" : "btn-inactive"
              }`}
            >
              {t("Personal Information")}
            </button>
          </Card>
          <Card className="border-card">
            <button
              onClick={() => onCardButtonClick("work")}
              id="card-button-work"
              variant="primary"
              className={`app-button btn-second margim-buttons ${
                buttonStatus.work ? "btn-active" : "btn-inactive"
              }`}
            >
              {t("Work")}
            </button>
          </Card>
          <Card className="border-card">
            <button
              onClick={() => onCardButtonClick("education")}
              id="card-button-education"
              variant="primary"
              className={`app-button btn-second margim-buttons ${
                buttonStatus.education ? "btn-active" : "btn-inactive"
              }`}
            >
              {t("Education")}
            </button>
          </Card>
          <Card className="border-card">
            <button
              onClick={() => onCardButtonClick("applicationDetails")}
              id="card-button-applicationDetails"
              variant="primary"
              className={`app-button btn-second margim-buttons ${
                buttonStatus.applicationDetails ? "btn-active" : "btn-inactive"
              }`}
            >
              {t("Application Details")}
            </button>
          </Card>
        </div>
        {buttonStatus.competence && (
          <div
            className="accordion accordion-flush"
            id="accordionFlushDocumentsCompetence"
          >
            <Competences
              changeCardStatus={() => changeCardStatus("competence")}
              cardStatus={cardStatus.competence}
            />
          </div>
        )}
        {buttonStatus.global && (
          <div
            className="accordion accordion-flush"
            id="accordionFlushDocumentsGlobal"
            style={{ marginTop: "15px" }}
          >
            <Global
              changeCardStatus={() => changeCardStatus("global")}
              cardStatus={cardStatus.global}
            />
          </div>
        )}
        {buttonStatus.condition && (
          <div
            className="accordion accordion-flush"
            id="accordionFlushDocumentsCondition"
            style={{ marginTop: "15px" }}
          >
            <Conditions
              changeCardStatus={() => changeCardStatus("condition")}
              cardStatus={cardStatus.condition}
            />
          </div>
        )}
        {buttonStatus.personal && (
          <div
            className="accordion accordion-flush"
            id="accordionFlushDocumentsPersonalInformation"
            style={{ marginTop: "15px" }}
          >
            <PersonalInformation
              changeCardStatus={() => changeCardStatus("personal")}
              cardStatus={cardStatus.personal}
            />
          </div>
        )}
        {buttonStatus.work && (
          <div
            className="accordion accordion-flush"
            id="accordionFlushDocumentsWork"
            style={{ marginTop: "15px" }}
          >
            <Work
              changeCardStatus={() => changeCardStatus("work")}
              cardStatus={cardStatus.work}
            />
          </div>
        )}
        {buttonStatus.education && (
          <div
            className="accordion accordion-flush"
            id="accordionFlushDocumentsEducation"
            style={{ marginTop: "15px" }}
          >
            <Education
              changeCardStatus={() => changeCardStatus("education")}
              cardStatus={cardStatus.education}
            />
          </div>
        )}
        {buttonStatus.applicationDetails && (
          <div
            className="accordion accordion-flush"
            id="accordionFlushDocumentsApplicationDetails"
            style={{ marginTop: "15px" }}
          >
            <ApplicationDetails
              changeCardStatus={() => changeCardStatus("applicationDetails")}
              cardStatus={cardStatus.applicationDetails}
            />
          </div>
        )}
      </div>
      <SaveSearch
        title={t("New search")}
        show={showSaveSearch}
        saveSearch={saveSearch}
        setShow={setShowSaveSearch}
      />
    </>
  );
}
